const statisticRoutes = [
  {
    path: "statistic",
    meta: {
      title: "통계",
      titleEn: "Statistic",
    },
    children: [
      // ------------------------------
      // 통계 > 프로그램 통계
      // ------------------------------
      {
        path: "programStudent", // statistic/programStudent
        meta: {
          title: "GQF 교육프로그램 통계",
          titleEn: "Program student",
          menuCd: "PROGRAM_STUDENT",
          isDynamic: true,
        },
        component: () =>
          import("@/views/statistic/StatisticProgramStudent/StatisticProgramStudentInha.vue"),
      },
      {
        path: "core", // statistic/core
        children: [
          {
            path: "",
            meta: {
              title: "GQF 역량진단 통계",
              titleEn: "Statistics of Core Competency Assessment",
              isDynamic: true,
              menuCd: "DIAG_CORE_STATISTICS",
            },
            component: () => import("@/views/diag/core/statistics/Statistics.vue"),
          },
        ],
      },
    ],
  },
];

export default statisticRoutes;
